import { useEffect, useState } from 'react'

import Api from 'services/api'

import Resource from 'types/Resource'

const useFthVideos = (searchText: string) => {
  const [fthVideos, setFthVideos] = useState<Array<Resource>>([])
  const [isFthLoading, setIsFthLoading] = useState(false)

  useEffect(() => {
    if (searchText.length === 0) {
      setFthVideos([])
      return
    }

    setIsFthLoading(true)
    Api.WistiaVideo.getFTHVideo(searchText)
      .then((res) => { setFthVideos(res) })
      .catch(() => { setFthVideos([]) })
      .finally(() => { setIsFthLoading(false) })
  }, [searchText])

  return { fthVideos, isFthLoading }
}

export default useFthVideos
